import React from "react";

const MESSAGE_REGISTRY = {
  FILE_TYPE: {
    SUCCESS: (data, showDetail) => {
      return <div>The input data type is of correct type.</div>;
    },
    WARNING: (data, showDetail) => {
      return <div></div>;
    },
    ERROR: (data, showDetail) => {
      return (
        <div>
          <strong>Critical: LogRatio cannot open your file.</strong>
          {showDetail && (
            <>
              <p>
                Your data must be in a CSV or MS Excel (with extension XLS or
                XLSX) file type.
              </p>
              <p>
                Excel file data must be in the first sheet, or LogRatio cannot
                run.
              </p>
            </>
          )}
        </div>
      );
    },
  },
  FILE_COMPLIANCE: {
    SUCCESS: (data, showDetail) => {
      return <div>The input file can be read.</div>;
    },
    WARNING: (data, showDetail) => {
      return <div></div>;
    },
    ERROR: (data, showDetail) => {
      return (
        <div>
          <strong>Critical: LogRatio cannot read your input file.</strong>
          {showDetail && (
            <p>
              Make sure the file is not corrupted, the file extension was not
              changed, and the survey data are stored in the first sheet of an
              Excel file.
            </p>
          )}
        </div>
      );
    },
  },
  MISSING_LABELS: {
    SUCCESS: (data, showDetail) => {
      return <div>The column labels have been detected.</div>;
    },
    WARNING: (data, showDetail) => {
      return <div></div>;
    },
    ERROR: (data, showDetail) => {
      return (
        <div>
          <strong>Critical: Missing column labels.</strong>
          {showDetail && (
            <>
              <p>
                LogRatio could not recognize one or more column labels of your
                input file.
              </p>
              <p>
                Please,{" "}
                <a
                  href="#!"
                  onClick={() => window.parent.postMessage({
                    cmd: "hyperlink",
                    url: "https://logratio.com/users-guide/#survey-data-how-to-format-your-input-file"
                  }, "https://logratio.com")}
                >
                  read this Help section
                </a>
                about how to format the data of your input file, make sure your
                data is compliant, and start LogRatio again.
              </p>
            </>
          )}
        </div>
      );
    },
  },
  EMPTY_ROWS: {
    SUCCESS: (data, showDetail) => {
      return <div>No empty rows detected.</div>;
    },
    WARNING: (data, showDetail) => {
      return <div></div>;
    },
    ERROR: (data, showDetail) => {
      return (
        <div>
          <strong>Critical: Remove empty rows</strong>
          {showDetail && (
            <p>
              Row {data} is empty. It must be removed or LogRatio may
              misinterpret your data.
            </p>
          )}
        </div>
      );
    },
  },
  MULTI_LABELS: {
    SUCCESS: (data, showDetail) => {
      return <div>The column labels are compliant.</div>;
    },
    WARNING: (data, showDetail) => {
      return <div></div>;
    },
    ERROR: (data, showDetail) => {
      return (
        <div>
          <strong>Error: Multi-answer problem</strong>
          {showDetail && (
            <>
              <p>
                There is a problem with the multiple answers to question {data}.
              </p>
              <p>Make sure the answers have the column labels on two rows.</p>
              <p>The first cell of the first row holds the question text.</p>
              <p>All other cells of the first row are empty. </p>
              <p>Each cell of the second row holds one answer class. </p>
              <p>
                In each column, the answers use the same words of the answer
                class of that column.
              </p>
              <p>
                <a
                  href="#!"
                  onClick={() => window.parent.postMessage({
                    cmd: "hyperlink",
                    url: "https://logratio.com/users-guide/#survey-data-how-to-format-your-input-file"
                  }, "https://logratio.com")}
                >
                  Read also this Help section.
                </a>
              </p>
            </>
          )}
        </div>
      );
    },
  },
  AMBIGUOUS_LABELS: {
    SUCCESS: (data, showDetail) => {
      return <div>The column labels are compliant.</div>;
    },
    WARNING: (data, showDetail) => {
      return <div></div>;
    },
    ERROR: (data, showDetail) => {
      return (
        <div>
          <strong>Critical: Ambiguous column labels.</strong>
          {showDetail && (
            <>
              <p>
                LogRatio could not understand some column labels of your input
                file.
              </p>
              <p>
                Please,{" "}
                <a
                  href="#!"
                  onClick={() => window.parent.postMessage({
                    cmd: "hyperlink",
                    url: "https://logratio.com/users-guide/#survey-data-how-to-format-your-input-file"
                  }, "https://logratio.com")}
                >
                  read this Help section
                </a>{" "}
                about how to format the data of your input file, make sure your
                data is compliant, and start LogRatio again.
              </p>
            </>
          )}
        </div>
      );
    },
  },
  NO_ID_COLUMN: {
    SUCCESS: (data, showDetail) => {
      return <div>Interview numbers detected.</div>;
    },
    WARNING: (data, showDetail) => {
      return <div></div>;
    },
    ERROR: (data, showDetail) => {
      return (
        <div>
          <strong>Critical: Missing interview numbers?</strong>
          {showDetail && (
            <>
              <p>
                LogRatio cannot detect the column with the unique interview
                identifiers, aka Interview ID.
              </p>
              <p>
                Make sure in your data file there is one column with all unique
                (not repeated) interview numbers or strings. LogRatio will use
                that column to identify single rows of data, hence one interview
                or respondent.
              </p>
            </>
          )}
        </div>
      );
    },
  },
  AMBIGUOUS_ID_COLUMN: {
    SUCCESS: (data, showDetail) => {
      return <div>Interview numbers verified.</div>;
    },
    WARNING: (data, showDetail) => {
      return (
        <div>
          <p>
            <strong>Warning: Ambiguous interview numbers</strong>
          </p>
          {showDetail && (
            <>
              <p>
                Each row of the survey data must have a unique ID, different
                from all other interviews.
              </p>
              <p>
                In your case, LogRatio detected more than one column made of
                unique interview identifiers, aka Interview ID.
              </p>
              <p>
                Therefore, column {data} has been arbitrarily chosen to identify
                single rows of data, hence one interview or respondent to your
                survey.
              </p>
              <p>
                To use a different column of data as Interview ID, move it in
                the first column of your dataset and run LogRatio again.
              </p>
            </>
          )}
        </div>
      );
    },
    ERROR: (data, showDetail) => {
      return <div></div>;
    },
  },
  SKIPPED_COLUMNS: {
    SUCCESS: (data, showDetail) => {
      return <div>No variables were skipped.</div>;
    },
    WARNING: (data, showDetail) => {
      return (
        <div>
          <strong>Warning: 1 or more variables will be skipped.</strong>
          {showDetail && (
            <>
              <p>
                The analysis will ignore the following variables because they
                are either continuous data or variables with one single answer
                class or are blank cells.
              </p>
              <ul>
                {data.map((col) => (
                  <li>{col}</li>
                ))}
              </ul>
            </>
          )}
        </div>
      );
    },
    ERROR: (data, showDetail) => {
      return <div></div>;
    },
  },
  TOO_FEW_OPEN_ANSWERS: {
    SUCCESS: (data, showDetail) => {
      return <div>Open questions have enough data.</div>;
    },
    WARNING: (data, showDetail) => {
      return (
        <div>
          <strong>
            Warning: Not enough data for 1 or more open questions.
          </strong>
          {showDetail && (
            <>
              <p>
                An open-ended question must have at least 10 answers (rows) for
                LogRatio to process it.
              </p>
              <ul>
                {data.map((col) => (
                  <li>{col}</li>
                ))}
              </ul>
            </>
          )}
        </div>
      );
    },
    ERROR: (data, showDetail) => {
      return <div></div>;
    },
  },
  SKIPPED_OPEN_QUESTIONS: {
    SUCCESS: (data, showDetail) => {
      return <div>No open questions were skipped.</div>;
    },
    WARNING: (data, showDetail) => {
      return (
        <div>
          <strong>Warning: Could not process 1 or more open questions.</strong>
          {showDetail && (
            <>
              <p>
                Some open-ended questions were dropped from the dataset because
                LogRatio could not recognize them.
              </p>
              <p>
                Please,{" "}
                <a
                  href="#!"
                  onClick={
                    () => window.parent.postMessage({
                      cmd: "hyperlink",
                      url: "https://logratio.com/users-guide/#survey-data-how-to-format-your-input-file"
                    }, "https://logratio.com")
                  }
                >
                  read this Help section
                </a>{" "}
                about how to format the data of your input file, make sure your
                data is compliant, and start LogRatio again.
              </p>
              <ul>
                {data.map((col) => (
                  <li>{col}</li>
                ))}
              </ul>
            </>
          )}
        </div>
      );
    },
    ERROR: (data, showDetail) => {
      return <div></div>;
    },
  },
  CLOSED_QUESTION_AMT: {
    SUCCESS: (data, showDetail) => {
      return <div>The closed-ended questions are compliant.</div>;
    },
    WARNING: (data, showDetail) => {
      return <div></div>;
    },
    ERROR: (data, showDetail) => {
      return (
        <div>
          <strong>Critical: Too few closed-ended questions.</strong>
          {showDetail && (
            <>
              <p>
                Your dataset must contain at least 3 closed-ended questions or
                LogRatio cannot run
              </p>
            </>
          )}
        </div>
      );
    },
  },
  INTERVIEW_MAX: {
    SUCCESS: (data, showDetail) => {
      return <div>Amount of data interviews (data rows) is not excessive.</div>;
    },
    WARNING: (data, showDetail) => {
      return <div></div>;
    },
    ERROR: (data, showDetail) => {
      // TODO: This error will not appear for the time being
      return (
        <div>
          <strong>Critical: Too many data rows.</strong>
          {showDetail && (
            <>
              <p>
                Reduce the number of data rows in your input file to 3,120 or
                less.
              </p>
            </>
          )}
        </div>
      );
    },
  },
  INTERVIEW_MIN: {
    SUCCESS: (data, showDetail) => {
      return <div>There are enough interviews (data rows).</div>;
    },
    WARNING: (data, showDetail) => {
      return <div></div>;
    },
    ERROR: (data, showDetail) => {
      return (
        <div>
          <strong>Critical: Not enough data</strong>
          {showDetail && (
            <>
              <p>
                Your input file must have between 6 and 3,120 data rows for
                LogRatio to process it.
              </p>
            </>
          )}
        </div>
      );
    },
  },
  UNIQUE_QUESTIONS: {
    SUCCESS: (data, showDetail) => {
      return <div>All questions are unique.</div>;
    },
    WARNING: (data, showDetail) => {
      return (
        <div>
          <p>
            <strong>Warning: Confusing question content.</strong>
          </p>
          {showDetail && (
            <>
              <p>
                Make sure the text of each question is unique to avoid a
                confusing LogRatio report.
              </p>
            </>
          )}
        </div>
      );
    },
    ERROR: (data, showDetail) => {
      return <div></div>;
    },
  },
  CLUSTER_ANALYSIS_OUTCOME: {
    SUCCESS: (data, showDetail) => {
      return <div>Cluster analysis successful.</div>;
    },
    WARNING: (data, showDetail) => {
      return (
        <div>
          <p>
            <strong>Warning: too many clusters.</strong>
          </p>
          (showDetail &&
          <>
            <p>
              The report of the cluster analysis by respondent can't be shown
              due to the very large number of small clusters it found.
            </p>
          </>
          )
        </div>
      );
    },
    ERROR: (data, showDetail) => {
      return <div></div>;
    },
  },
};

const SolutionField = ({ messageId, kind, extra_data, showDetail }) => {
  return <div>{MESSAGE_REGISTRY[messageId][kind](extra_data, showDetail)}</div>;
};

export default SolutionField;
